"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointFeature = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Feature_1 = __importDefault(require("ol/Feature"));
const Point_1 = __importDefault(require("ol/geom/Point"));
const proj_1 = require("ol/proj");
const react_1 = require("react");
const useMemoized_1 = require("../../hooks/useMemoized");
const OLFeature_1 = require("../../openlayers/OLFeature");
function PointFeature(_a) {
    var { coordinates } = _a, props = __rest(_a, ["coordinates"]);
    const feature = react_1.useMemo(() => {
        const feature = new Feature_1.default({ geometry: new Point_1.default(proj_1.fromLonLat([0, 0])) });
        feature.setId(Math.random());
        return feature;
    }, []);
    const memoizedCoordinates = useMemoized_1.useMemoized(coordinates);
    react_1.useLayoutEffect(() => {
        feature.getGeometry().setCoordinates(proj_1.fromLonLat(memoizedCoordinates));
    }, [feature, memoizedCoordinates]);
    return jsx_runtime_1.jsx(OLFeature_1.OLFeature, Object.assign({ feature: feature }, props), void 0);
}
exports.PointFeature = PointFeature;
//# sourceMappingURL=index.js.map